module.exports = __webpack_public_path__ + "static/media/Deleted.fc7c5ede.svg";